import { put, select, takeLatest } from 'redux-saga/effects';
import { getProductScope } from '@discover-frontend/utils';
import {
  SEND_EVENT_REQUEST,
  SEND_EVENT_SUCCESS,
  SEND_STATE_CHANGE_EVENT,
  SEND_STATE_CHANGE_SUCCESS,
} from '../constants/action-types';


function* fetchSendEvent(action) {
  const currentLoggedUserEmail = yield select(state => state.me.data.email);
  if (process.env.REACT_APP_API_ENV === 'production') {
    window.hj('identify', currentLoggedUserEmail, {
      email: currentLoggedUserEmail,
    });
    window.hj('event', `${action.event}`);
    window.gtag('event', action.event, {
      app_name: getProductScope(),
    });
  }

  return yield put({ type: SEND_EVENT_SUCCESS });
}

function* fetchSendStateChange(action) {
  if (process.env.REACT_APP_API_ENV === 'production') {
    window.hj('stateChange', action.url);
  }

  return yield put({ type: SEND_STATE_CHANGE_SUCCESS });
}

export function* eventsActionWatcher() {
  yield takeLatest(SEND_EVENT_REQUEST, fetchSendEvent);
  yield takeLatest(SEND_STATE_CHANGE_EVENT, fetchSendStateChange);
}
